@if (!(fieldConfig.hideIfEmpty && formArray && formArray.length == 0)) {
  <div class="nested-table" [ngStyle]="{ width: fieldConfig.tableWidth || '100%' }">
    @if (loading) {
      <div class="spinner-element">
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    }
    @if (!fieldConfig.noLabel) {
      <div class="action-container">
        @if (fieldConfig.help) {
          <button mat-icon-button color="primary" [matTooltip]="fieldConfig.help">
            <mat-icon class="info-icon">help</mat-icon>
          </button>
        }
        {{ fieldConfig.label }}
      </div>
    }
    @if (!loading) {
      <div [hidden]="!tableData" class="add-container">
        @if (canEdit && editMode && canAdd) {
          <button data-id="pushNewBtn" mat-button (click)="pushOnTop()" class="add-element-button">
            <span class="push-new">Push new</span>
            <mat-icon>add</mat-icon>
          </button>
        }
        <table cdkDropList mat-table [dataSource]="tableData" class="table-data" multiTemplateDataRows>
          <ng-container matColumnDef="expander">
            <th mat-header-cell *matHeaderCellDef [style.text-align]=""></th>
            <td mat-cell *matCellDef="let element" class="actions-cell">
              @if (mayBeExpanded(element)) {
                <div>
                  @if (!element.expanded) {
                    <mat-icon (click)="toggleRowExpansion(element)" data-id="expandInputPlayerRow" class="info-icon"
                      >keyboard_arrow_right
                    </mat-icon>
                  }
                  @if (element.expanded) {
                    <mat-icon (click)="toggleRowExpansion(element)" class="info-icon">keyboard_arrow_down </mat-icon>
                  }
                </div>
              }
            </td>
          </ng-container>
          <ng-container [matColumnDef]="'select'">
            <th mat-header-cell *matHeaderCellDef class="row-small"></th>
            <td mat-cell *matCellDef="let element">
              @if (element.visible && fieldConfig.canReorder && canEdit && editMode && isGameLinkTable()) {
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="toggleRow(element)"
                  [checked]="selection.isSelected(element)"
                  [attr.data-id]="'checkboxInstance_' + (element.gameInstance?.name || '')">
                </mat-checkbox>
              }
            </td>
          </ng-container>
          @for (field of fields; track field; let i = $index) {
            <ng-container [matColumnDef]="field.name">
              <th
                mat-header-cell
                *matHeaderCellDef
                [style.text-align]="field.align"
                [style.max-width]="field.type === 'checkbox' || field.type === 'image' ? '90px' : 'auto'"
                [style]="transform(field.tableCss)">
                @if (field.help) {
                  <button mat-icon-button color="primary" [matTooltip]="field.help">
                    <mat-icon class="help-icon">help</mat-icon>
                  </button>
                }
                {{ field.label }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                [style]="transform(field.tableCss)"
                [style.text-align]="field.align"
                [attr.data-id]="element.gameInstance?.name ? 'instanceName_' + element.gameInstance.name : ''">
                <app-table-cell
                  [rowData]="element"
                  [formGroup]="convertToFormGroup(formArray.controls[element.index])"
                  [editMode]="canEdit && editMode"
                  [type]="field.type"
                  [data]="element[field.name]"
                  [attr.data-id]="'field_' + field.name"
                  [fieldConfig]="field"></app-table-cell>
              </td>
            </ng-container>
          }
          <ng-container [matColumnDef]="'drag-and-drop'">
            <th mat-header-cell *matHeaderCellDef class="drop-container"></th>
            <td mat-cell *matCellDef="let element" class="element">
              @if (fieldConfig.canReorder && canEdit && editMode) {
                <button
                  [attr.data-id]="'dragAndDropInstance_' + element.gameInstance?.name"
                  mat-icon-button
                  color="primary"
                  matTooltip="Drag and drop"
                  class="drop-cursor"
                  cdkDragHandle>
                  <i class="fas fa-arrows-alt"></i>
                </button>
              }
            </td>
          </ng-container>
          <ng-container [matColumnDef]="'menu'">
            <th mat-header-cell *matHeaderCellDef class="actions-container"></th>
            <td mat-cell *matCellDef="let element" class="nestes-table-actions">
              @if (!isGameLinkTable() && ((canEdit && this.canAdd) || fieldConfig.actions?.length > 0)) {
                <button mat-icon-button [matMenuTriggerFor]="rowOptionMenu">
                  <mat-icon>more_vert</mat-icon>
                </button>
              }
              @if (canEdit && this.canAdd && editMode && fieldConfig.actions?.length === 0) {
                <button mat-icon-button (click)="deleteRow(element)" color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              }
              <mat-menu #rowOptionMenu="matMenu">
                @if (fieldConfig.canAdd && this.canRemove && this.canEdit && this.editMode) {
                  <button mat-menu-item (click)="deleteRow(element)">
                    <mat-icon>delete</mat-icon>
                    Remove
                  </button>
                }
                @for (action of fieldConfig.actions; track action) {
                  <app-action
                    [data]="element"
                    [actionConfig]="action"
                    [menuItemMode]="true"
                    (onResponse)="actionFinished($event)"></app-action>
                }
              </mat-menu>
            </td>
          </ng-container>
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element"
              [attr.colspan]="displayedFieldsNames.length"
              class="example-element-container">
              <div class="example-element-detail" [@detailExpand]="element.expanded ? 'expanded' : 'collapsed'">
                <div class="example-element-description">
                  <span class="example-element-description-attribution">
                    @for (field of expandedFields; track field) {
                      <span>
                        @if (!isIgnored(field, element)) {
                          <span>
                            @if (field.type !== 'nested_table') {
                              <span class="field-expanded-section">
                                @if (!field.noLabel) {
                                  <span class="label-info">{{ field.label }}:</span>
                                }
                                <app-form-field
                                  [formGroup]="convertToFormGroup(formArray.controls[element.index])"
                                  [rowData]="element"
                                  [editMode]="canEdit && editMode"
                                  [type]="field.type"
                                  [data]="element[field.name]"
                                  [fieldConfig]="field">
                                </app-form-field>
                              </span>
                            } @else {
                              <div class="field-container">
                                @if (!field.noLabel) {
                                  <span class="field-label"> {{ field.label }}: </span>
                                }
                                <app-form-field
                                  [formGroup]="convertToFormGroup(formArray.controls[element.index])"
                                  [editMode]="canEdit && editMode"
                                  [type]="field.type"
                                  [data]="element[field.name]"
                                  [fieldConfig]="field"
                                  [rowData]="element">
                                </app-form-field>
                              </div>
                            }
                          </span>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedFieldsNames"></tr>
          <tr
            [class.rowodd]="true"
            [hidden]="!(editMode && canEdit) || !fieldConfig.canReorder"
            (cdkDragDropped)="droppedElement($event, row)"
            cdkDrag
            mat-row
            *matRowDef="let row; columns: displayedFieldsNames"
            class="example-element-row"
            [class.expendable]="expandedFields && expandedFields.length > 0"
            [class.example-expanded-row]="!!row.expanded"></tr>
          <tr
            data-id="fieldRow"
            [class.roweven]="true"
            [hidden]="editMode && canEdit && fieldConfig.canReorder"
            mat-row
            *matRowDef="let row; columns: displayedFieldsNames"
            class="example-element-row"
            [class.expendable]="expandedFields && expandedFields.length > 0"
            [class.example-expanded-row]="!!row.expanded"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: expandedFields.length > 0 ? ['expandedDetail'] : []"
            class="example-detail-row"></tr>
        </table>
        @if (editMode && canEdit && canAdd && isGameLinkTable() && tableData) {
          <div class="table-action-buttons">
            <button
              [disabled]="!selectionHasValue()"
              mat-raised-button
              color="secondary"
              class="button-edit"
              (click)="moveSelectedRowsToTop()"
              data-id="moveSelectedGamesToTopBtn">
              <mat-icon>sort</mat-icon><span>Move Selected Games to Top</span>
            </button>
          </div>
        }
        @if (editMode && canEdit && canAdd) {
          <button mat-button (click)="appendRow()" class="add-element-button">
            <span class="info-label">Append new</span>
            <mat-icon>add</mat-icon>
          </button>
        }
        @if (pageableData && pageableData.content) {
          <mat-paginator
            class="page-paginator"
            [length]="pageableData.total"
            [pageSize]="pageableData.perPage"
            [pageIndex]="pageableData.offset"
            [pageSizeOptions]="[50, 100, 200]"
            [showFirstLastButtons]="true"
            (page)="pageChanged($event)">
          </mat-paginator>
        }
        @if (formArray.hasError('required')) {
          <mat-error class="error-info"> You need to add at least one element </mat-error>
        }
      </div>
    }
  </div>
}
